export default {"src":"/_next/static/media/call.77f6c8a0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};